import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import { useEffect, useState } from "react";
import { getNavigationTree, type NavigationTreeDataDTO } from "../api/getNavigationTree";
import Spinner from "../../common/components/Spinner/Spinner";
import { toggleNotifications } from "../api/toggleNotifications";
import { Permission, userHasAnyPermission } from "../../utils/permissions";
import { redirectToUrl } from "../../utils/url/urlUtils";
import { HOMEPAGE } from "../../utils/url/staticUrls";
import { NotificationSettingsNavigation } from "./NotificationSettingsNavigation";

import classes from "./NotificationSettingsPage.module.less";
import { NotificationSettings } from "~/Notifications/NotificationSettingsPage/NotificationSettings";
import { useTranslation } from "react-i18next";

export function NotificationSettingsPage() {
  const canSeeNotifications = userHasAnyPermission(Permission.SEE_NOTIFICATIONS);

  if (!canSeeNotifications) {
    redirectToUrl(HOMEPAGE);
  }

  const { t } = useTranslation();
  const [data, setData] = useState<NavigationTreeDataDTO[]>([]);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    getNavigationTree().then((response) => {
      setData(response);
      setLoading(false);
    });
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const onChange = (isParent: boolean, type: string, state: boolean) => {
    const requestData = isParent
      ? {
          parent: type,
          parentEnabled: state,
        }
      : {
          child: type,
          childEnabled: state,
        };

    toggleNotifications(requestData).then((response) => {
      if (response) {
        getData();
      }
    });
  };

  return (
    <div className={classes.page}>
      <div className={classes.pageTitle}>
        <PageTitle title={t("notificationsSettingsPage.title")} />
      </div>

      <NotificationSettingsNavigation className={classes.navigation} navigation={data} />

      <div className={classes.settings}>
        {loading && <Spinner className="mb-3" />}

        <NotificationSettings data={data} onToggle={onChange} />
      </div>
    </div>
  );
}

export function createNotificationSettingsPage() {
  return <NotificationSettingsPage />;
}
